import Image from 'next/image';

const logos = [
  { src: '/logos/usc.png', alt: 'USC', height: 40 },
  { src: '/logos/carleton.png', alt: 'Carleton University', height: 56 },
  { src: '/logos/lspark.svg', alt: 'L-SPARK', height: 22 },
  { src: '/logos/yukon.png', alt: 'Government of Yukon', height: 48 },
];

export default function TrustBar() {
  return (
    <section className="py-10 border-t border-b border-border">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="flex items-center justify-between gap-8 flex-wrap">
          {logos.map((logo) => (
            <Image
              key={logo.alt}
              src={logo.src}
              alt={logo.alt}
              width={180}
              height={logo.height}
              className="opacity-40 grayscale hover:opacity-60 transition-opacity object-contain"
              style={{ height: `${logo.height}px`, width: 'auto', maxWidth: '180px' }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
